import React, { useState } from 'react';
import style from '../../style.module.scss';
import { LiveClassesList } from '../../../organisms/live_classes_list';
import { useYourClassesContext } from '../../context';
import { pluralize } from 'utilities/pluralize';
import { DefaultButton } from '@magoosh/lib/button';
import { Icon } from '../../../assets/icons';

export const RegisteredContent: React.FC = () => {
  const { data, fetchData } = useYourClassesContext();
  const [displayCount, setDisplayCount] = useState(6);

  React.useEffect(() => {
    fetchData('registered');
    const intervalId = setInterval(() => {
      fetchData('registered', true);
    }, 1000 * 60);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleSeeMore = () => {
    setDisplayCount(data.registered.past.length);
  };

  return (
    <>
      <LiveClassesList
        icon={<Icon iconType="DateStar" fill={style.brandSecondary} />}
        title="Your Upcoming Classes"
        description={`You’re registered for ${pluralize(
          data.registered.upcoming.length,
          'upcoming class.',
          'upcoming classes.'
        )}`}
        liveClasses={data.registered.upcoming}
      />

      <LiveClassesList
        icon={<Icon iconType="DateCheck" fill={style.brandPrimary} color={style.brandPrimaryDarker} />}
        title="Your Past Classes"
        liveClasses={data.registered.past.slice(0, displayCount)}
      />
      {displayCount < data.registered.past.length && (
        <div className="text-center u-margin-A-s">
          <DefaultButton onClick={handleSeeMore}>See More</DefaultButton>
        </div>
      )}
    </>
  );
};

export default RegisteredContent;
